import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TCAvatarComponent, TCAvatarGroupComponent } from './components/avatar';
import { TCColorPickerComponent, TCPickerComponent } from './components/color-picker';
import { TCDropdownButtonComponent, TCDropdownComponent, TCDropdownContentComponent } from './components/dropdown';
import { TCListComponent, TCListItemComponent } from './components/list';
import { TCRadioComponent, TCRadioOptionComponent } from './components/radio';
import { TCTableColComponent, TCTableComponent } from './components/table';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TCAlertComponent } from './components/alert';
import { TCAlignDirective } from './directives/align/align.directive';
import { TCAutocompleteComponent } from './components/autocomplete';
import { TCBadgeComponent } from './components/badge';
import { TCBgColorDirective } from './directives/bg-color/bg-color.directive';
import { TCBorderColorDirective } from './directives/border-color/border-color.directive';
import { TCBorderStyleDirective } from './directives/border-style/border-style.directive';
import { TCButtonComponent } from './components/button';
import { TCCardComponent } from './components/card';
import { TCCardHeaderDirective } from './directives/card-header/card-header.directive';
import { TCCheckboxComponent } from './components/checkbox';
import { TCCircleProgressComponent } from './components/circle-progress';
import { TCColorDirective } from './directives/color/color.directive';
import { TCContactComponent } from './components/contact';
import { TCFilterTableDirective } from './directives/filter-table/filter-table.directive';
import { TCFocusDirective } from './directives/focus/focus.directive';
import { TCFontSizeDirective } from './directives/font-size/font-size.directive';
import { TCFormDescriptionComponent } from './components/form-description';
import { TCFormGroupComponent } from './components/form-group';
import { TCFormLabelComponent } from './components/form-label';
import { TCGradientDirective } from './directives/gradient/gradient.directive';
import { TCGroupComponent } from './components/group';
import { TCIconComponent } from './components/icon';
import { TCInputComponent } from './components/input';
import { TCListAvatarDirective } from './directives/list-avatar/list-avatar.directive';
import { TCListIconDirective } from './directives/list-icon/list-icon.directive';
import { TCListImageSizeDirective } from './directives/list-image-size/list-image-size.directive';
import { TCListLineDirective } from './directives/list-line/list-line.directive';
import { TCModalComponent } from './components/modal';
import { TCPaginationComponent } from './components/pagination';
import { TCProgressComponent } from './components/progress';
import { TCRatingComponent } from './components/rating';
import { TCSelectComponent } from './components/select';
import { TCShapeDirective } from './directives/shape/shape.directive';
import { TCSortTableDirective } from './directives/sort-table/sort-table.directive';
import { TCSpinnerComponent } from './components/spinner';
import { TCSwitcherComponent } from './components/switcher';
import { TCTextareaComponent } from './components/textarea';
import { TCUserComponent } from './components/user';
import { TCVTimelineComponent } from './components/v-timeline';

// import { DragulaModule } from 'ng2-dragula';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    // DragulaModule.forRoot(),
  ],
  declarations: [
    TCBgColorDirective,
    TCBorderColorDirective,
    TCCardHeaderDirective,
    TCBorderStyleDirective,
    TCColorDirective,
    TCFocusDirective,
    TCGradientDirective,
    TCShapeDirective,
    TCFontSizeDirective,
    TCAlignDirective,
    TCSortTableDirective,
    TCFilterTableDirective,
    TCListLineDirective,
    TCButtonComponent,
    TCCardComponent,
    TCSpinnerComponent,
    TCTableComponent,
    TCTableColComponent,
    TCInputComponent,
    TCTextareaComponent,
    TCFormDescriptionComponent,
    TCFormGroupComponent,
    TCFormLabelComponent,
    TCPaginationComponent,
    TCCheckboxComponent,
    TCContactComponent,
    TCSwitcherComponent,
    TCAutocompleteComponent,
    TCRadioComponent,
    TCRadioOptionComponent,
    TCBadgeComponent,
    TCDropdownComponent,
    TCDropdownButtonComponent,
    TCDropdownContentComponent,
    TCIconComponent,
    TCVTimelineComponent,
    TCSelectComponent,
    TCAlertComponent,
    TCRatingComponent,
    TCAvatarComponent,
    TCColorPickerComponent,
    TCPickerComponent,
    TCModalComponent,
    TCListComponent,
    TCListItemComponent,
    TCListAvatarDirective,
    TCListIconDirective,
    TCListImageSizeDirective,
    TCProgressComponent,
    TCCircleProgressComponent,
    TCAvatarGroupComponent,
    TCUserComponent,
    TCGroupComponent
  ],
  exports: [
    TCBgColorDirective,
    TCBorderColorDirective,
    TCCardHeaderDirective,
    TCBorderStyleDirective,
    TCColorDirective,
    TCGradientDirective,
    TCShapeDirective,
    TCFontSizeDirective,
    TCAlignDirective,
    TCSortTableDirective,
    TCFocusDirective,
    TCListIconDirective,
    TCListAvatarDirective,
    TCListLineDirective,
    TCListImageSizeDirective,
    TCButtonComponent,
    TCCardComponent,
    TCSpinnerComponent,
    TCTableComponent,
    TCTableColComponent,
    TCInputComponent,
    TCTextareaComponent,
    TCFormDescriptionComponent,
    TCFormGroupComponent,
    TCFormLabelComponent,
    TCCheckboxComponent,
    TCContactComponent,
    TCSwitcherComponent,
    TCAutocompleteComponent,
    TCRadioComponent,
    TCRadioOptionComponent,
    TCBadgeComponent,
    TCDropdownComponent,
    TCDropdownButtonComponent,
    TCDropdownContentComponent,
    TCIconComponent,
    TCVTimelineComponent,
    TCSelectComponent,
    TCAlertComponent,
    TCRatingComponent,
    TCAvatarComponent,
    TCColorPickerComponent,
    TCPickerComponent,
    TCModalComponent,
    TCListComponent,
    TCListItemComponent,
    TCProgressComponent,
    TCCircleProgressComponent,
    TCAvatarGroupComponent,
    TCUserComponent,
    TCGroupComponent
  ],
  entryComponents: [TCModalComponent],
})
export class UIModule { }
